import { LayoutComponent } from "../layout/layout.component";
import { PublicLayoutComponent } from "../layout/public-layout/public-layout.component";
import { OnboardingLayoutComponent } from "../layout/onboarding-layout/onboarding-layout.component";
import { authGuard } from "../core/_guards/auth.guard";
import { UserResolverService } from "../core/resolver/user-resolver/userresolverservice.service";
import { Routes } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { RoleType } from "../core/_models/role";
import { ProductresolverService } from "../core/resolver/product-resolver/productresolver.service";
import { InitialpasswordresetComponent } from "./initialpasswordreset/initialpasswordreset.component";
import { UserprofileComponent } from "../shared/component/userprofile/userprofile.component";

export const routes: Routes = [
  // Public routes FIRST (no authentication required)
  {
    path: "public",
    component: PublicLayoutComponent,
    children: [
      {
        path: "shop",
        loadComponent: () =>
          import("./shop/shop-overview/shop-overview.component").then(
            (m) => m.ShopOverviewComponent,
          ),
        data: {
          breadcrumb: "breadcrumb.SHOP",
        },
      },
      {
        path: "cart",
        loadComponent: () =>
          import("./shop/public-cart/public-cart.component").then(
            (m) => m.PublicCartComponent,
          ),
        data: {
          breadcrumb: "breadcrumb.CART",
        },
      },
    ],
  },

  // Onboarding routes (authenticated, no sidebar)
  {
    path: "onboarding",
    component: OnboardingLayoutComponent,
    canActivate: [authGuard],
    resolve: {
      user: UserResolverService,
    },
    children: [
      { path: "", redirectTo: "welcome", pathMatch: "full" },
      {
        path: "setup",
        loadComponent: () =>
          import("./onboarding/onboarding.component").then((m) => m.OnboardingComponent),
      },
      {
        path: "welcome",
        loadComponent: () =>
          import("./onboarding/onboarding-welcome/onboarding-welcome.component").then(
            (m) => m.OnboardingWelcomeComponent,
          ),
      },
    ],
  },

  // Authenticated routes
  {
    path: "",
    component: LayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    resolve: {
      user: UserResolverService,
    },
    children: [
      { path: "", redirectTo: "home", pathMatch: "full" },
      {
        path: "home",
        component: HomeComponent,
        data: {
          breadcrumb: "breadcrumb.HOME",
        },
      },
      {
        path: "privacy",
        loadComponent: () =>
          import("./privacy/privacy.component").then((m) => m.PrivacyComponent),
        data: {
          breadcrumb: "footer.PRIVACY",
        },
      },
      {
        path: "account",
        loadChildren: () => import("./account/account.routes").then((m) => m.routes),
        data: {
          breadcrumb: "breadcrumb.ACCOUNT",
        },
      },
      {
        path: "connector",
        loadChildren: () => import("./connectors/connectors.route").then((m) => m.routes),
        data: {
          breadcrumb: "breadcrumb.CONNECTOR",
        },
      },
      {
        path: "calendars",
        loadComponent: () =>
          import("./calendars/calendar.component").then((m) => m.CalendarComponent),
        data: {
          breadcrumb: "breadcrumb.CALENDARS",
        },
      },
      {
        path: "resources",
        loadChildren: () => import("./resources/resources.routes").then((m) => m.routes),
        data: {
          breadcrumb: "breadcrumb.RESOURCES",
        },
      },
      {
        path: "maps",
        loadChildren: () => import("./maps/maps.routes").then((m) => m.routes),
        data: {
          breadcrumb: "breadcrumb.MAPS",
        },
      },
      {
        path: "news-stream",
        loadChildren: () => import("./news/news-stream.routes").then((m) => m.routes),
        data: {
          breadcrumb: "breadcrumb.NEWSSTREAM",
        },
      },
      {
        path: "room-service",
        loadChildren: () =>
          import("./room-service/room-service.routes").then((m) => m.routes),
        data: {
          breadcrumb: "breadcrumb.ROOMSERVICE",
        },
      },
      {
        path: "insights-dashboard",
        loadComponent: () =>
          import("./insights-dashboard/insights-dashboard.component").then(
            (m) => m.InsightsDashboardComponent,
          ),
        data: {
          breadcrumb: "breadcrumb.INSIGHTS",
        },
      },
      {
        path: "devices",
        loadComponent: () =>
          import("./devices/devices.component").then((m) => m.DevicesComponent),
        data: {
          breadcrumb: "breadcrumb.DEVICES",
        },
      },
      {
        path: "licenses",
        loadComponent: () =>
          import("./licenses/licenses.component").then((m) => m.LicensesComponent),
        data: {
          breadcrumb: "breadcrumb.LICENSES",
        },
      },
      {
        path: "shop",
        loadChildren: () => import("./shop/shop.routes").then((m) => m.routes),
        data: {
          breadcrumb: "breadcrumb.SHOP",
        },
        resolve: {
          products: ProductresolverService,
        },
      },
      {
        path: "settings",
        loadChildren: () => import("./settings/settings.routes").then((m) => m.routes),
        data: {
          breadcrumb: "breadcrumb.SETTINGS",
        },
      },
      {
        path: "userprofile",
        data: {
          breadcrumb: "breadcrumb.USERPROFILE",
        },
        component: UserprofileComponent,
      },
      {
        path: "",
        loadChildren: () => import("./admin/admin.routes").then((m) => m.routes),
        data: {
          roles: [RoleType.HXAMaster, RoleType.Reseller, RoleType.ProviderSupportAdmin],
          breadcrumb: "breadcrumb.ADMIN",
        },
      },
    ],
  },

  // Not Lazy Routes
  // {
  //   path: "imprint",
  //   component: LoginComponent,
  //   resolve: {
  //     url: "externalRedirectResolver",
  //   },
  //   data: {
  //     externalUrl: "https://hxa.io/impressum",
  //   },
  // },

  // {
  //   path: "faq",
  //   component: LoginComponent,
  //   resolve: {
  //     url: "externalRedirectResolver",
  //   },
  //   data: {
  //     externalUrl: "https://docs.hxa.io/",
  //   },
  // },

  // {
  //   path: "community",
  //   component: LoginComponent,
  //   resolve: {
  //     url: "externalRedirectResolver",
  //   },
  //   data: {
  //     externalUrl: "https://community.hxa.io/",
  //   },
  // },

  {
    path: "resetpassword",
    component: InitialpasswordresetComponent,
    canActivate: [authGuard],
  },

  // Not found - redirect to home which will trigger login
  { path: "**", redirectTo: "home" },
];
